import React from 'react';

/** Bold, consistently-cased inline mention of the OpenUse brand name. */
const Brand: React.FC = () => <strong className="brand">OpenUse</strong>;

export default Brand;
